import styles from './delete-version-dialog.module.scss';
import { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { IProductVersion } from '../../_models/product-version';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface DeleteVersionDialogProps {
  open: boolean,
  onClose: () => void,
  getData: () => void,
  version: IProductVersion,
  versionGroupId: string
}

export function DeleteVersionDialog(props: DeleteVersionDialogProps) {
  const { t } = useTranslation();
  const makeRequest = useMakeRequestHook();
  const { setSnackbarMessage } = useContext(SnackBarContext);

  const handleDeleteVersion = () => {
    makeRequest(`productVersions/${props.versionGroupId}/versions/${props.version.id}`, 'DELETE')
      .then(result => {
        setSnackbarMessage({ content: t("deleteVersion.versionDeleted"), type: "success" });
        props.getData();
        props.onClose();
      }).catch(() => setSnackbarMessage({ content: t("deleteVersion.couldNotDeleteVersion"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth='sm'>
      <DialogTitle className='mb-3'>
        {t("standard.areYouSureYouWantToDelete")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'>
          {t("standard.version")}: {props.version.versionName}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          onClick={handleDeleteVersion}
          className='minButtonWidth'>
          {t("standard.deleteVersion")}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteVersionDialog;